"use client";
import React from "react";
import MysnoryLayout from "../../shared/pictureCard/mysnoryLayout";
import { useDisplayModeContext } from "@/app/context/displayModeStore";
import TagCard from "./tagCard";

interface TagCardWrapperProps {
  data: any[];
  style: string;
  translations: any;
}

const TagCardWrapper: React.FC<TagCardWrapperProps> = ({ data, style, translations }) => {
  const { state } = useDisplayModeContext();

  return (
    <MysnoryLayout state={state}>
      {data.map((tag, i) => (
        <TagCard key={i} tag={tag} style={style} state={state} translations={translations} />
      ))}
    </MysnoryLayout>
  );
};

export default TagCardWrapper;
